import { render, staticRenderFns } from "./MyPlanCard.vue?vue&type=template&id=0650a3f1&scoped=true&"
import script from "./MyPlanCard.vue?vue&type=script&lang=ts&"
export * from "./MyPlanCard.vue?vue&type=script&lang=ts&"
import style0 from "./MyPlanCard.vue?vue&type=style&index=0&id=0650a3f1&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0650a3f1",
  null
  
)

export default component.exports